import tinycolor from "tinycolor2";

import type { AppointmentState } from "../types";

export interface AppointmentTheme {
  accentColor: string;
  accentDark: string;
  accentDeep: string;
  gradientBackground: string;
}

export const getGradientFromColor = (accentColor = "#2b73b9"): AppointmentTheme => {
  const baseColor = accentColor || "#2b73b9";
  const accentDark = tinycolor(baseColor).darken(18).toHexString();
  const accentDeep = tinycolor(baseColor).darken(32).toHexString();
  const gradientBackground = `linear-gradient(180deg, ${baseColor} 0%, ${accentDark} 55%, ${accentDeep} 100%)`;

  return {
    accentColor: baseColor,
    accentDark,
    accentDeep,
    gradientBackground,
  };
};

export const getAppointmentTheme = (
  appointment?: Pick<AppointmentState, "shopData">
): AppointmentTheme => {
  const accentColor = appointment?.shopData?.color || "#2b73b9";
  const { accentDark, accentDeep, gradientBackground } =
    getGradientFromColor(accentColor);

  return {
    accentColor,
    accentDark,
    accentDeep,
    gradientBackground,
  };
};
